import React, { Component } from "react";
import {
    MDBContainer,
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
} from "mdbreact";
import domain from '../domain'
import axios from 'axios'
import { MDBInput } from "mdbreact";
import { FadeLoader } from "react-spinners";
/**
 *  Home Page Popup Modal
 */
import { Progress } from 'semantic-ui-react'

import colors from "../colors";
import ReactHTMLParser from "react-html-parser";
import moment from "moment";
var validExt = ".pdf"
function fileExtValidate(file) {
    var filePath = file.name
    var getFileExt = filePath.substring(filePath.lastIndexOf('.'))
    var pos = validExt.indexOf(getFileExt)
    if (pos < 0) {
        alert('This file is not allowed, Please upload the valid file format')
        return false
    }
    else
        return true
}

var maxSize = '10024'
function fileSizeValidate(fdata) {
    console.log(fdata.size)
    if (fdata.size) {
        var fsize = fdata.size / 1024
        if (fsize > maxSize) {
            alert('Maximum file size exceed, This file size is: ' + fsize + 'KB')
            return false
        }
        else {
            return true
        }
    }
}
class UploadModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            progress: 0,
            loading: false
        }
    }
    setProgress = (value) => {
        console.log(value)
        this.setState({
            progress: value
        })
    }
    onFileChange = (e) => {
        var type = e.target.files[0].type;
        console.log(type)
        console.log(e.target.files[0])
        this.setState({
            selectedFile: e.target.files[0]
        })
    }
    onFileUpload = async () => {
        if (this.state.selectedFile) {
            let result = fileExtValidate(this.state.selectedFile)
            let result2 = fileSizeValidate(this.state.selectedFile)
            console.log(result, result2)
            if (result && result2) {
                const formdata = new FormData()
                formdata.append("myFile", this.state.selectedFile, this.props.requestid + "_" + this.state.selectedFile.name)

                console.log(this.state.selectedFile)
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    },
                    onUploadProgress: data => {
                        this.setProgress(Math.round((100 * data.loaded) / data.total))
                    }
                };
                this.setState({
                    loading: true
                })
                let result = await axios.post(`${domain.Fileserver}/upload_files`, formdata, config)
                console.log(result)
                var requestid = this.props.requestid
                if (result) {
                    const data = {
                        user: window.sessionStorage.getItem("loginUser"),
                        requestid: requestid,
                        filename: requestid + "_" + this.state.selectedFile.name,

                        status: '1'
                    }
                    let result = await axios.post(`${domain.DBServer}/update-glof-status-file`, data)
                    if (result) {
                        console.log(result)
                        if (result.data) {
                            this.setState({
                                loading: false
                            })
                            this.props.uploadToggle()


                        }
                    }


                }
            }
        }

    }
    render() {

        return (
            <MDBContainer >
                {/* <MDBBtn color="primary" onClick={this.toggle(14)}>MDBModal</MDBBtn> */}
                <MDBModal
                    isOpen={this.props.uploadmodal}
                    toggle={this.props.uploadToggle}
                    centered
                    backdrop={false}
                    size="lg"

                >
                    <MDBModalHeader
                        className="text-center"
                        titleClass="w-100 font-weight-bold"
                        toggle={this.toggle}
                        style={{ background: "#3f51b5", color: "white" }}
                        toggle={this.props.uploadToggle}
                    >
                        {this.props.title}
                    </MDBModalHeader>
                    <MDBModalBody
                        style={{
                            textAlign: "justify",
                            //height: window.innerHeight > 1000 ? "500px" : "300px",

                            overflowY: "scroll",
                        }}
                    >
                        <div class="form-group row justify-content-center">
                            <div class="col-sm-12">
                                <div className="input-group">
                                    {/* <div className="input-group-prepend">
                                        <span className="input-group-text" id="inputGroupFileAddon01">
                                            Upload
                                                        </span>
                                    </div> */}
                                    <div className="custom-file">
                                        <input
                                            type="file"
                                            className="custom-file-input"
                                            id="inputGroupFile01"
                                            aria-describedby="inputGroupFileAddon01"
                                            onChange={this.onFileChange} 
                                            accept=".pdf"
                                        />
                                        <label className="custom-file-label" htmlFor="inputGroupFile01">
                                            {this.state.selectedFile!==null?this.state.selectedFile.name:'Choose File'}
                                        </label>
                                    </div>
                                </div>
                                <p>*Please upload a file less than 2MB &amp; PDF file.</p>
                                {/* <p>*Please upload PDF file </p> */}


                                {/* <input type="file" onChange={this.onFileChange} /><br /> */}
                                <button className="btn btn-primary btn-sm" onClick={this.onFileUpload}>Upload</button><br /><br />

                            </div>
                            {this.state.progress !== 0 ?
                                <div className="sweet-loading">
                                    <FadeLoader
                                        sizeUnit={"px"}
                                        color={"#123abc"}
                                        loading={this.state.loading}
                                    />
                                </div> : null}

                        </div>

                        {/* {
                this.state.loading?
                <div className="sweet-loading">
                        <FadeLoader
                          sizeUnit={"px"}
                          color={"#123abc"}
                          loading={this.state.loading}
                        />
                      </div>:null
              } */}
                    </MDBModalBody>
                    {/* <MDBModalFooter>
            
          </MDBModalFooter> */}
                </MDBModal>
            </MDBContainer>
        );
    }
}

export default UploadModal;
